
const showVeil = (targetEl, active = true) => {
    const $target = $(targetEl || 'body');
    let $veil = $target.find('.bg-block');
    
    if (!$veil.length) {
        $veil = $('<div class="bg-block"></div>');
        $target.prepend($veil);
    }

    if (active) {
        // Required to show animation fade
        setTimeout(() => {
            $veil.addClass('active');
        })
    }
    return $veil;
}

const removeVeil = (targetEl) => {
    const $target = $(targetEl);
    const $veil = $target.find('.bg-block');
    if (!$veil.length) {
        return undefined;
    }

    $veil.one('transitionend', ()=> {
        $veil.remove();
    });
    
    $veil.removeClass('active');
    return $veil;
}

module.exports = {
    add: showVeil,
    remove: removeVeil
}